import React, { useState } from 'react';
import BlotterUpload from './BlotterUpload';
import BlotterList from './BlotterList';

const BlotterManagement: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Daily Blotter Upload
          </h1>
          <p className="text-gray-600">
            Upload CSV or Excel files to process daily trading blotters
          </p>
        </div>

        {/* Upload Section */}
        <div className="mb-8">
          <BlotterUpload onUploadSuccess={handleRefresh} />
        </div>

        {/* Blotters List */}
        <BlotterList onRefresh={handleRefresh} key={refreshKey} />
      </div>
    </div>
  );
};

export default BlotterManagement;
